import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    title: {
      fontSize: '1.6rem',
      marginBottom: '1.4rem',
    },
    radioRoot: {
      color: theme.palette.secondary.light,
      '&.Mui-checked': {
        color: '#005375',
      },
    },
    formControlLabelRoot: {
      maxWidth: '22rem',
      '& > span': {
        fontSize: '3.5rem',
      },
      '& > section > div': {
        fontSize: '1.4rem',
        fontWeight: 600,
        lineHeight: 1.4,
      },
      '& > section > span': {
        display: 'inline-block',
        fontSize: '1.2rem',
        lineHeight: 1.2,
      },
    },
    memberName: {
      fontWeight: 600,
      marginBottom: theme.spacing(-0.6),
    },
    fieldset: {
      width: '100%',
      '& > div': {
        justifyContent: 'space-between',
      },
    },
  }),
)
